import ToolStylus from './ToolStylus';

class ToolStylusTemplate extends ToolStylus {
  static toolName = 'Template';

  static action() {
    return true;
  }
}

export default ToolStylusTemplate;
